import { Title } from '@components/styled/Title.styled';
import { MapPinIcon } from '@src/assets';
import React from 'react';
import * as styled from './styled/AddressGroup.styled';
import { TitleGroup } from './styled/TitleGroup.styled';

export const AddressGroup: React.FC<{
    address?: string;
}> = ({ address }) => {
    return (
        <styled.AddressGroup>
            <TitleGroup>
                <MapPinIcon />
                <styled.Wrapper>
                    <Title>{'Vacation home address'}</Title>
                    <div>{address}</div>
                </styled.Wrapper>
            </TitleGroup>
        </styled.AddressGroup>
    );
};
